import * as React from "react";

import {
  NotificationDispatchContext,
  ShowNotification,
} from "./NotificationContext";

export function useNotification(): ShowNotification {
  return React.useContext(NotificationDispatchContext);
}
